export default "__VITE_ASSET__1c87a05a__"